import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";

import Subscribe from "../../../components/Library/Subscribe";
import styles from "./Header.css";

class Header extends Component {
  render() {
    return (
      <div className={classNames(styles.header, this.props.className)}>
        <div className={styles.content}>
          {this.props.subText && (
            <div className={styles.subText}>{this.props.subText}</div>
          )}
          {this.props.subscription ? (
            <Link
              to={`/newsletters/${this.props.subscription.slug}`}
              className={styles.mainText}
            >
              {this.props.text}
            </Link>
          ) : (
            <h2 className={styles.mainText}>{this.props.text}</h2>
          )}
          {this.props.subscription && (
            <Subscribe
              className={styles.subscribe}
              subscription={this.props.subscription}
            />
          )}
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  subText: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string,
  subscription: PropTypes.shape({
    slug: PropTypes.string.isRequired,
  }),
};

export default Header;
